import styled from 'styled-components';

const imageLarge = '400px';
const imageMedium = '300px';
const imageSmall = '250px';

export const MainContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  @media screen and (max-width: 600px) {
    flex-direction: column;
  }
`;

export const QuestionContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  border-right: solid 1px #cccccc;
  @media screen and (max-width: 600px) {
    border-right: none;
  }
`;

export const QuestionIuputContainer = styled.div`
  width: 90%;
`;

export const VideoContainer = styled.iframe`
  width: 100%;
  height: 100%;
`;

export const OptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 300px;
  align-items: center;
`;

export const OptionInnerContainer = styled.div`
  width: 230px;
  margin: 10px 0;

  & h4 {
    margin-block-start: 0;
    margin-block-end: 0;
  }
`;

export const AnswerFieldContainer = styled.div`
  max-width: 680px;
  margin: 20px;
`;

export const AnswerOuterContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  @media screen and (max-width: 700px) {
    display: flex;
    flex-direction: column;
  }
`;

export const AnswerContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 250px;
  justify-content: center;
`;

export const CheckBoxContainer = styled.div`
  padding-top: 15px;
  margin-left: -20px;
  
`;
export const RadioContainer = styled.div`
  padding-top: 15px;
  margin-left: -30px;
  
`;

export const AddImageContainer = styled.div`
  border: dashed 5px #e9e9e9;
  width: ${imageLarge};
  height: ${imageLarge};
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  @media screen and (max-width: 600px) {
    width: ${imageMedium};
    height: ${imageMedium};
  }
  @media screen and (min-width: 601px) and (max-width: 900px) {
    width: ${imageSmall};
    height: ${imageSmall};
  }
`;

export const AddImageContainerNoBorder = styled(AddImageContainer)`
  border: none;
  flex-direction: column;
`;

export const Image = styled.img`
  width: ${imageLarge};
  @media screen and (max-width: 600px) {
    width: ${imageMedium};
  }
  @media screen and (min-width: 601px) and (max-width: 900px) {
    width: ${imageSmall};
  }
`;
